export const c_skeleton_Width = {
  "name": "--pf-v5-c-skeleton--Width",
  "value": "75%",
  "var": "var(--pf-v5-c-skeleton--Width)"
};
export default c_skeleton_Width;